/* BF intl landing (sections/bf-intl.liquid). */
(() => {
  // Before/after carousel: the track is a CSS scroll-snap strip, so swipe works natively;
  // the arrows scroll it by one slide.
  document.querySelectorAll('[data-bfi-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-bfi-track]');
    const step = (dir) => track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
    carousel.querySelector('[data-bfi-prev]')?.addEventListener('click', () => step(-1));
    carousel.querySelector('[data-bfi-next]')?.addEventListener('click', () => step(1));
  });

  // Sticky signup bar: move it above the store header (both stick at the top) and keep the
  // header stuck just below it.
  const bar = document.querySelector('[data-bfi-bar]');
  if (!bar) return;
  const header = document.querySelector('.shopify-section-group-header-group');
  if (header) header.before(bar);
  const root = document.documentElement;
  const setHeight = () => root.style.setProperty('--bfi-bar-h', `${bar.offsetHeight}px`);
  setHeight();
  root.classList.add('bfi-has-bar');
  new ResizeObserver(setHeight).observe(bar);

  // The button scrolls to the hero signup and puts the cursor in the email field.
  bar.querySelector('[data-bfi-bar-cta]')?.addEventListener('click', (event) => {
    const form = document.getElementById('BfIntlHero');
    if (!form) return;
    event.preventDefault();
    form.closest('.bfi-signup')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    form.querySelector('input[type="email"]')?.focus({ preventScroll: true });
  });
})();
